import { Component, Input, OnInit, ChangeDetectorRef, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { DateAdapter, MatSelect, MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import {IMyDpOptions, IMyDateModel, MyDatePicker} from 'mydatepicker';
import { Cliente } from '../../cliente/cliente.model';
import { Parametric } from '../../cliente/parametric.model';
import { ApiService } from '../../core/api.service';
import { PaisCliente } from '../../cliente/paisCliente.model';

interface IDateForPicker {
  date: {
    year: number,
    month: number,
    day: number
  };
}
interface Bank {
  id: string;
  name: string;
 }

@Component({
  selector: 'app-usuario-datos-personales',
  templateUrl: './usuario-datos-personales.component.html',
  styleUrls: ['./usuario-datos-personales.component.scss']
})
export class UsuarioDatosPersonalesComponent implements OnInit {

  @Input() cliente: Cliente;
  @Input() buttonClicked = true;

  private isPersonaFisica = false;

  @ViewChild('mydp') mydp: MyDatePicker;

  modelForDatePicker: any;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    sunHighlight: false,
    satHighlight: false,
    showInputField: false,
    showClearDateBtn: false
  };

  constructor(
    private cdRef: ChangeDetectorRef,
    private apiService: ApiService
  ) {
  }

  ngOnInit() {
    if (this.cliente.fechaNacimiento) {
      const date = new Date(Number(this.cliente.fechaNacimiento.substr(0, 4)),
                            Number(this.cliente.fechaNacimiento.substr(6, 2)),
                            Number(this.cliente.fechaNacimiento.substr(10, 2)));
      this.setDateModelForPicker(
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        date.getUTCDate());
    }
  }

  // dateChanged callback function called when the user select the date. This is mandatory callback
  // in this option. There are also optional inputFieldChanged and calendarViewChanged callbacks.
  onDateChanged(event: IMyDateModel) {
    // event properties are: event.date, event.jsdate, event.formatted and event.epoc
    const fechaNacimiento = event.jsdate;
    if (fechaNacimiento) {
      this.cliente.fechaNacimiento = fechaNacimiento.toISOString();
    }
  }

  onBirthDateTextBoxBlur(date) {
    if (date.length === 10) {

      const dateParts = date.split('/');
      const year = +dateParts[2];
      const month =  +dateParts[1];
      const day = +dateParts[0];

      this.setDateModelForPicker(year, month, day);
    }
  }

  private setDateModelForPicker(year: number, month: number, day: number) {
    this.modelForDatePicker = {
      date:
       {
         year: year,
         month: month,
         day: day
        }
      };
  }

  onTogglePicker(event) {
    event.stopPropagation();
    this.mydp.openBtnClicked();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-personales/usuario-datos-personales.component.ts